module.exports = __webpack_public_path__ + "img/couples-012.4337722e.jpg";